import Seo from "@/components/Seo";
import { PageHeader } from "@/components/Bits";
import { CONTACT } from "@/data/catalog";

function Block({ title, children }) {
  return (
    <div className="border-b border-border py-8">
      <h2 className="font-display text-xl font-600 uppercase tracking-tight text-foreground">{title}</h2>
      <div className="mt-3 space-y-3 font-body text-sm text-muted-foreground">{children}</div>
    </div>
  );
}

export default function Datenschutz() {
  return (
    <>
      <Seo
        title="Datenschutz"
        description="Datenschutzerklärung der IMPEXMILTRADE GMBH gemäß DSGVO und TKG 2003."
      />
      <PageHeader
        code="RECHTLICH / DSGVO"
        title="Datenschutz"
        sub="Erklärung zur Informationspflicht. Der Schutz Ihrer persönlichen Daten ist uns ein besonderes Anliegen — wir verarbeiten Ihre Daten ausschließlich auf Grundlage der gesetzlichen Bestimmungen (DSGVO, TKG 2003)."
      />

      <section className="mx-auto max-w-4xl px-5 py-16" data-testid="datenschutz-content">
        <div className="border-t border-border">
          <Block title="Kontakt mit uns">
            <p>
              Wenn Sie per Formular auf der Website oder per E-Mail Kontakt mit uns aufnehmen, werden Ihre
              angegebenen Daten zwecks Bearbeitung der Anfrage und für den Fall von Anschlussfragen sechs
              Monate bei uns gespeichert. Diese Daten geben wir nicht ohne Ihre Einwilligung weiter.
            </p>
          </Block>

          <Block title="Cookies">
            <p>
              Unsere Website verwendet so genannte Cookies. Dabei handelt es sich um kleine Textdateien, die
              mit Hilfe des Browsers auf Ihrem Endgerät abgelegt werden. Sie richten keinen Schaden an.
            </p>
            <p>
              Wir nutzen Cookies dazu, unser Angebot nutzerfreundlich zu gestalten. Einige Cookies bleiben
              auf Ihrem Endgerät gespeichert, bis Sie diese löschen. Sie ermöglichen es uns, Ihren Browser
              beim nächsten Besuch wiederzuerkennen. Wenn Sie dies nicht wünschen, so können Sie Ihren
              Browser so einrichten, dass er Sie über das Setzen von Cookies informiert und Sie dies nur im
              Einzelfall erlauben. Bei der Deaktivierung von Cookies kann die Funktionalität unserer Website
              eingeschränkt sein.
            </p>
          </Block>

          <Block title="Web-Analyse">
            <p>
              Unsere Website verwendet Funktionen des Webanalysedienstes Google Analytics. Anbieter ist die
              Google Inc., 1600 Amphitheatre Parkway, Mountain View, CA 94043, USA. Dazu werden Cookies
              verwendet, die eine Analyse der Benutzung der Website durch Ihre Benutzer ermöglichen. Die
              dadurch erzeugten Informationen werden auf den Server des Anbieters übertragen und dort
              gespeichert. Sie können dies verhindern, indem Sie Ihren Browser so einrichten, dass keine
              Cookies gespeichert werden. Wir haben mit dem Anbieter einen entsprechenden Vertrag zur
              Auftragsdatenverarbeitung abgeschlossen.
            </p>
          </Block>

          <Block title="IP-Anonymisierung">
            <p>
              Wir haben auf dieser Website die Funktion IP-Anonymisierung aktiviert. Dadurch wird Ihre
              IP-Adresse von Google innerhalb von Mitgliedsstaaten der Europäischen Union oder in anderen
              Vertragsstaaten des Abkommens über den Europäischen Wirtschaftsraum vor der Übermittlung in die
              USA gekürzt. Nur in Ausnahmefällen wird die volle IP-Adresse an einen Server von Google in den
              USA übertragen und dort gekürzt. Im Auftrag des Betreibers dieser Website wird Google diese
              Informationen benutzen, um Ihre Nutzung der Website auszuwerten, um Reports über die
              Websiteaktivitäten zusammenzustellen und um weitere mit der Websitenutzung und der
              Internetnutzung verbundene Dienstleistungen gegenüber dem Websitebetreiber zu erbringen. Die im
              Rahmen von Google Analytics von Ihrem Browser übermittelte IP-Adresse wird nicht mit anderen
              Daten von Google zusammengeführt.
            </p>
          </Block>

          <Block title="Browser Plugin">
            <p>
              Sie können die Speicherung der Cookies durch eine entsprechende Einstellung Ihrer
              Browser-Software verhindern; wir weisen Sie jedoch darauf hin, dass Sie in diesem Fall
              gegebenenfalls nicht sämtliche Funktionen dieser Website vollumfänglich werden nutzen können.
              Sie können darüber hinaus die Erfassung der durch den Cookie erzeugten und auf Ihre Nutzung der
              Website bezogenen Daten (inkl. Ihrer IP-Adresse) an Google sowie die Verarbeitung dieser Daten
              durch Google verhindern, indem Sie das unter folgendem Link verfügbare Browser-Plugin
              herunterladen und installieren: https://tools.google.com/dlpage/gaoptout?hl=de
            </p>
          </Block>

          <Block title="Ihre Rechte">
            <p>
              Ihnen stehen grundsätzlich die Rechte auf Auskunft, Berichtigung, Löschung, Einschränkung,
              Datenübertragbarkeit, Widerruf und Widerspruch zu. Wenn Sie glauben, dass die Verarbeitung
              Ihrer Daten gegen das Datenschutzrecht verstößt oder Ihre datenschutzrechtlichen Ansprüche
              sonst in einer Weise verletzt worden sind, können Sie sich bei der Aufsichtsbehörde beschweren.
              In Österreich ist dies die Datenschutzbehörde.
            </p>
          </Block>

          <div className="py-8">
            <h2 className="font-display text-xl font-600 uppercase tracking-tight text-foreground">
              Sie erreichen uns unter folgenden Kontaktdaten
            </h2>
            <address className="mt-4 not-italic font-body text-foreground">
              IMPEXMILTRADE GMBH
              <br />
              Hauptplatz 36
              <br />
              A-8480 Mureck
              <br />
              <a href={`tel:${CONTACT.phoneHref}`} className="hover:text-primary">Tel.: {CONTACT.phone}</a>
              <br />
              <a href={`mailto:${CONTACT.email}`} className="hover:text-primary">{CONTACT.email}</a>
            </address>
          </div>
        </div>
      </section>
    </>
  );
}
